import { VueModule } from '@Foundation/utilities';
import simpleList from './code/Scripts/components/simple-list';

export default VueModule({
  components: {
    simpleList
  }
});
